var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
            ]),
            _c("el-breadcrumb-item", { attrs: { to: { path: "/addGoods" } } }, [
              _c("div", { staticClass: "div2" }, [_vm._v("添加商品")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "baisc" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("基本信息")]),
        _c(
          "el-form",
          { staticClass: "demo-form-inline", attrs: { model: _vm.baisc } },
          [
            _c(
              "div",
              { staticClass: "nav" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商品主图" } },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "upload",
                        staticClass: "upload-demo",
                        attrs: {
                          "list-type": "picture",
                          action: "#",
                          "show-file-list": false,
                          "auto-upload": true,
                          "http-request": _vm.safeImport,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              size: "small",
                              type: "primary",
                            },
                            slot: "trigger",
                          },
                          [_vm._v("点击上传")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "notes" }, [
                      _c("p", [
                        !_vm.is_null(_vm.imageUrl)
                          ? _c("img", {
                              directives: [
                                {
                                  name: "image-preview",
                                  rawName: "v-image-preview",
                                },
                              ],
                              staticClass: "avatar",
                              attrs: { src: _vm.ImgHttps + _vm.imageUrl },
                            })
                          : _vm._e(),
                        !_vm.is_null(_vm.imageUrl)
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.close(_vm.index)
                                  },
                                },
                              },
                              [_vm._v("×")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "stock" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品标题", "label-width": "70px" } },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "128",
                            placeholder: "请输入商品标题",
                          },
                          model: {
                            value: _vm.baisc.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.baisc, "title", $$v)
                            },
                            expression: "baisc.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品编号", "label-width": "70px" } },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "10",
                            placeholder: "请输入商品编号",
                          },
                          model: {
                            value: _vm.baisc.nort,
                            callback: function ($$v) {
                              _vm.$set(_vm.baisc, "nort", $$v)
                            },
                            expression: "baisc.nort",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "选择品牌" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择产品品牌",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.baisc.brand,
                          callback: function ($$v) {
                            _vm.$set(_vm.baisc, "brand", $$v)
                          },
                          expression: "baisc.brand",
                        },
                      },
                      _vm._l(_vm.brandselect, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.name, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "品牌分类" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.options,
                        props: {
                          checkStrictly: true,
                          label: "name",
                          value: "id",
                          children: "children",
                        },
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.baisc.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.baisc, "category", $$v)
                        },
                        expression: "baisc.category",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "guige" }, [
              _c("p", { staticClass: "header" }, [_vm._v("规格价格")]),
              _c(
                "div",
                { staticClass: "standards" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品规格" } },
                    _vm._l(_vm.commDictonary, function (items) {
                      return _c(
                        "el-radio-group",
                        {
                          key: items.id,
                          staticStyle: { "margin-right": "10px" },
                          model: {
                            value: _vm.baisc.resource,
                            callback: function ($$v) {
                              _vm.$set(_vm.baisc, "resource", $$v)
                            },
                            expression: "baisc.resource",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: items.id } }, [
                            _vm._v(_vm._s(items.name)),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "stock" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品重量", "label-width": "70px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "128",
                              placeholder: "请输入商品重量",
                            },
                            model: {
                              value: _vm.baisc.weight,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "weight", $$v)
                              },
                              expression: "baisc.weight",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.baisc.resource == "件"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品数量",
                                max: 999999999,
                                min: 0,
                                controls: false,
                                "label-width": "70px",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: { placeholder: "请输入商品一件的总量" },
                                model: {
                                  value: _vm.baisc.number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.baisc, "number", $$v)
                                  },
                                  expression: "baisc.number",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品价格", "label-width": "70px" } },
                    [
                      _c(
                        "div",
                        { staticClass: "price" },
                        [
                          _c("el-input", {
                            attrs: { controls: false, placeholder: "优惠价" },
                            model: {
                              value: _vm.baisc.newPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "newPrice", $$v)
                              },
                              expression: "baisc.newPrice",
                            },
                          }),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "30px" } },
                            [_vm._v("元")]
                          ),
                          _c("el-input", {
                            attrs: { controls: false, placeholder: "市场价" },
                            model: {
                              value: _vm.baisc.oldPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "oldPrice", $$v)
                              },
                              expression: "baisc.oldPrice",
                            },
                          }),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "30px" } },
                            [_vm._v("元")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "stock1" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品仓库" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                multiple: "",
                                "value-key": "id",
                                placeholder: "请选择商品类别",
                              },
                              on: { change: _vm.stockE },
                              model: {
                                value: _vm.baisc.wareHouse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.baisc, "wareHouse", $$v)
                                },
                                expression: "baisc.wareHouse",
                              },
                            },
                            _vm._l(_vm.house, function (items) {
                              return _c("el-option", {
                                key: items.id,
                                attrs: { value: items, label: items.name },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "wareHouse" },
                    _vm._l(_vm.houseName, function (items, index) {
                      return _c(
                        "span",
                        { key: index },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: items.name } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  placeholder: "请输入商品库存",
                                },
                                model: {
                                  value: items.value,
                                  callback: function ($$v) {
                                    _vm.$set(items, "value", $$v)
                                  },
                                  expression: "items.value",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总库存", "label-width": "70px" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "", value: _vm.totalCount },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "stock" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品厂家", "label-width": "70px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "128",
                              placeholder: "请输入商品厂家",
                            },
                            model: {
                              value: _vm.baisc.cj,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "cj", $$v)
                              },
                              expression: "baisc.cj",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品介绍" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "1024", type: "textarea" },
                        model: {
                          value: _vm.baisc.desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.baisc, "desc", $$v)
                          },
                          expression: "baisc.desc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "stock" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { label: "是否上架" },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 0, "inactive-value": 1 },
                            model: {
                              value: _vm.baisc.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "status", $$v)
                              },
                              expression: "baisc.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "jurisdictionBox" }, [
                _c("p", { staticClass: "header" }, [_vm._v("销售权限")]),
                _c(
                  "div",
                  { staticClass: "jurisdiction" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "可以销售" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.checkboxChange },
                            model: {
                              value: _vm.checkedCities,
                              callback: function ($$v) {
                                _vm.checkedCities = $$v
                              },
                              expression: "checkedCities",
                            },
                          },
                          _vm._l(_vm.selectList, function (city) {
                            return _c(
                              "el-checkbox",
                              {
                                key: city.dictId,
                                attrs: { label: city.dictId },
                              },
                              [_vm._v(_vm._s(city.dictName))]
                            )
                          }),
                          1
                        ),
                        _vm.enterIf
                          ? _c(
                              "div",
                              {
                                staticClass: "inter",
                                staticStyle: { "margin-left": "90px" },
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 1 },
                                    model: {
                                      value: _vm.baisc.tgInter,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.baisc, "tgInter", $$v)
                                      },
                                      expression: "baisc.tgInter",
                                    },
                                  },
                                  [_vm._v("内部")]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: 2 },
                                    model: {
                                      value: _vm.baisc.tgInter,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.baisc, "tgInter", $$v)
                                      },
                                      expression: "baisc.tgInter",
                                    },
                                  },
                                  [_vm._v("总部")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.tolist },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }